import { buildIresDeviceFrame } from "./FrameBuilder";

const COMMAND_FLAG_START_STOP_PANEL = 0x01;
const COMMAND_FLAG_READ_PROGRAM = 0x03;
const COMMAND_FLAG_FACTORY_RESET = 0x66;
const COMMAND_FLAG_READ_CONFIG = 0x1C;
const COMMAND_FLAG_LOAD_RUNS = 0x0a;

// Increased from 4 to 8 on 09.10.2025 to improve loading efficiency and reduce total request cycles.
// This adjustment doubles the runs per response while keeping total bandwidth usage within safe limits.
const MAX_RUNS_PER_RESPONSE = 8; // Limit for number of runs returned in a single response

export function buildStartPanelFrame(program: number) {
  const command = new Uint8Array(2);

  command[0] = COMMAND_FLAG_START_STOP_PANEL;
  command[1] = program & 0xff;

  return buildIresDeviceFrame(command);
}

export function buildStopPanelCommand(): string {
  const command = new Uint8Array(2);

  command[0] = COMMAND_FLAG_START_STOP_PANEL;
  command[1] = 0x00;

  return buildIresDeviceFrame(command);
}

export function buildReadProgramFrame(programNumber: number): string {
  const command = new Uint8Array(2);

  command[0] = COMMAND_FLAG_READ_PROGRAM;
  command[1] = programNumber;

  return buildIresDeviceFrame(command);
}

export function buildReadConfigFrame(): string {
  const command = new Uint8Array(1);

  command[0] = COMMAND_FLAG_READ_CONFIG;

  return buildIresDeviceFrame(command);
}

export function buildFactoryResetFrame(): string {
  const command = new Uint8Array(1);

  command[0] = COMMAND_FLAG_FACTORY_RESET;

  return buildIresDeviceFrame(command);
}

export function buildLoadRunsFrame(
  programRunId: number
): string {
  const command = new Uint8Array(4);

  command[0] = COMMAND_FLAG_LOAD_RUNS;

  if (programRunId < 0) {
    command[1] = 0;
    command[2] = 0;
  } else {
    command[1] = 2;
    command[2] = programRunId;
  }

  // ==================== FIRMWARE v4.0.0+ CHANGES ====================
  command[3] = MAX_RUNS_PER_RESPONSE; // Set number of runs to load in response

  return buildIresDeviceFrame(command);
}
